__turbopack_context__.v({
  "active": "Header-module__arFiJq__active",
  "hamburger": "Header-module__arFiJq__hamburger",
  "listItem": "Header-module__arFiJq__listItem",
  "listItemLink": "Header-module__arFiJq__listItemLink",
  "logo": "Header-module__arFiJq__logo",
  "navContainer": "Header-module__arFiJq__navContainer",
  "navList": "Header-module__arFiJq__navList",
});
